/* globals axios route */

import ErrorHandler from '../core/ErrorHandler';
import { merge } from '../core/helpers';

export default {
  props: {
    route: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      items: [],
      dataSet: {},
      fetching: false,
    };
  },

  mounted() {
    this.fetch();
    Event.listen('onpopstate', () => this.fetch());
    Event.listen('refreshCollection', () => this.fetch());
  },

  methods: {
    findIndex(item) {
      return this.items.findIndex(currentItem => currentItem.id === item.id);
    },

    push(item) {
      if (this.findIndex(item) === -1) {
        this.items.push(item);
        this.increaseTotal();
      }
    },

    prepend(item) {
      if (this.findIndex(item) === -1) {
        this.items.unshift(item);
        this.increaseTotal();
      }
    },

    remove(item) {
      const index = this.findIndex(item);

      if (index !== -1) {
        this.items.splice(index, 1);
        this.decreaseTotal();
      }
    },

    update(item) {
      const index = this.findIndex(item);

      if (index !== -1) {
        merge(this.items[index], item);
      }
    },

    increaseTotal() {
      this.dataSet.meta.total = this.dataSet.meta.total + 1;
    },

    decreaseTotal() {
      this.dataSet.meta.total = this.dataSet.meta.total - 1;
    },

    fetch() {
      if (this.fetching) {
        return;
      }
      this.fetching = true;
      axios.get(this.url())
        .then(({ data }) => {
          this.fetching = false;
          this.refresh(data);
        })
        .catch((error) => {
          this.fetching = false;
          (new ErrorHandler(error)).dispatch();
        });
    },

    refresh(data) {
      this.dataSet = data;
      this.items = data.data;
    },

    url() {
      const params = new URLSearchParams(window.location.search);
      return `${route(this.route)}?${params.toString()}`;
    },
  },
};
